"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * Creates a [React component updater](https://github.com/GrantGryczan/react-component-updater#react-component-updater).
 *
 * Usage:
 * ```
 * const [useMyComponentUpdater, updateMyComponent] = createUpdater();
 * ```
 *
 * ```
 * // Call this inside any component you want to update.
 * useMyComponentUpdater();
 * ```
 *
 * ```
 * // Call this to update any hooked components.
 * updateMyComponent();
 * ```
 */
var createUpdater = function () {
    var currentState = false;
    var updateStates = [];
    /** Call this to update any hooked components. */
    var update = function () {
        currentState = !currentState;
        for (var i = 0; i < updateStates.length; i++) {
            updateStates[i]();
        }
    };
    /** Call this inside any component you want to update. */
    var useUpdater = function () {
        var _a = react_1.useState(currentState), setState = _a[1];
        var updateStateRef = react_1.useRef();
        // `updateState` must be set synchronously so that `setState` calls are effective even before the component is fully mounted.
        if (!updateStateRef.current) {
            var updateState = function () {
                setState(currentState);
            };
            updateState._index = updateStates.push(updateState) - 1;
            updateStateRef.current = updateState;
        }
        react_1.useEffect(function () { return function () {
            // Delete `updateState` from `updateStates` in O(1) by popping the last item and swapping it into this item's place (unless this item is the popped item).
            var lastUpdateState = updateStates.pop();
            if (lastUpdateState !== updateStateRef.current) {
                updateStates[updateStateRef.current._index] = lastUpdateState;
                lastUpdateState._index = updateStateRef.current._index;
            }
        }; }, []);
    };
    return [useUpdater, update];
};
exports.default = createUpdater;
